// keys.ts — RQ cache keys for the subscription suite. Private.

const SUBSCRIPTION_QUERY_KEY = {
  Root: 'subscription',
  Current: 'current',
  Usage: 'usage',
  Plans: 'plans',
} as const;

export const subscriptionKeys = {
  all: [SUBSCRIPTION_QUERY_KEY.Root] as const,
  current: () => [...subscriptionKeys.all, SUBSCRIPTION_QUERY_KEY.Current] as const,
  usage: () => [...subscriptionKeys.all, SUBSCRIPTION_QUERY_KEY.Usage] as const,
  plans: () => [...subscriptionKeys.all, SUBSCRIPTION_QUERY_KEY.Plans] as const,
};
